import * as ReportActions from './report.actions';
import * as fromApp from '../../store/app.reducers';
import { ChartInfo } from '../chart-info.model';

/*
export interface FeatureState extends fromApp.AppState {
  charts: State
}
*/

export interface State {
  charts: ChartInfo[];
}


const initialState = {
  charts: [
    {
      chartType: 'doughnut',
      data: [350, 450, 100],
      labels: ['Male', 'Female', 'Other']
    },
    {
      chartType: 'boxPlot',
      data: [
        {
          label: 'One',
          values: {
            Q1: 180,
            Q2: 200,
            Q3: 250,
            whisker_low: 115,
            whisker_high: 400,
            outliers: [50, 100, 425]
          }
        },
        {
          label: 'Two',
          values: {
            Q1: 300,
            Q2: 350,
            Q3: 400,
            whisker_low: 225,
            whisker_high: 425,
            outliers: [175, 450, 480]
          }
        }
    ],
    labels: []
    }



    ,
    {
      chartType: 'boxPlot',
      data: [
        {
          label: 'Three',
          values: {
            Q1: 100,
            Q2: 200,
            Q3: 300,
            whisker_low: 115,
            whisker_high: 400,
            outliers: [50, 100, 425]
          }
        },
        {
          label: 'Four',
          values: {
            Q1: 200,
            Q2: 300,
            Q3: 450,
            whisker_low: 225,
            whisker_high: 425,
            outliers: [175, 450, 480]
          }
        }
    ],
    labels: []
    },
    {
      chartType: 'radar',
      data: [
        {data: [65, 59, 90, 81, 56, 55, 40], label: 'Series A'},
        {data: [28, 48, 40, 19, 96, 27, 100], label: 'Series B'}
      ],
      labels: ['Activation', 'Activation Confidence', 'Dominance', 'Dominance Confident'
              , 'Valence', 'Valence Confidence']
    },
    {
      chartType: 'bar',
      data: [
        {data: [65, 59, 80], label: 'Female'},
        {data: [-28, 48, 40], label: 'Male'}
        ],
      labels: ['first', 'second', 'third']
    },

    {
      chartType: 'bar',
      data: [
        {data: [65, 59, 80, 24], label: 'Female'},
        {data: [-28, 48, 40, -24], label: 'Male'}
        ],
      labels: ['first', 'second', 'third', 'forth']
    },

    {
      chartType: 'bar',
      data: [
        {data: [65, 59, 80, 24, 1], label: 'Female'},
        {data: [-28, 48, 40, -24, 1], label: 'Male'}
        ],
      labels: ['first', 'second', 'third', 'forth', 'fifth']
    },
    {
      chartType: 'polarArea',
      data: [300, 500, 100, 40, 120],
      labels: ['first', 'second', 'third', 'forth', 'fifth']
    },

    {
      chartType: 'polarArea',
      data: [120, 200, 70],
      labels: ['one', 'two', 'three']
    },
    {
      chartType: 'pie',
      data: [300, 500, 100, 100],
      labels: ['first', 'second', 'third', 'forth']
    },
    {
      chartType: 'line',
      data: [
        {data: [-65, 59, 80, -81], label: 'Series A'},
        {data: [28, 48, 40, 19], label: 'Series B'}
      ],
      labels: ['January', 'February', 'March', 'April']
    },
    {
      chartType: 'lineTable',
      data: [
        {data: [-65, 59, 80, -81, 56, 55, 40], label: 'Series A'},
        {data: [28, 48, 40, 19, 86, -27, 90], label: 'Series B'}
      ],
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July']
    }



  ]


};

export function reportReducer(state = initialState, action: ReportActions.ReportActions) {
  switch (action.type) {
    case (ReportActions.SET_CHARTS):
      return {
        ...state,
        charts: [...action.payload]
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/report/store/report.reducers.ts